import { useQuery } from "react-query";
import { getCodeLevels } from "../../../../../actions/Utilities/CodeLevel";

const useGetCodeLevels = (businessTypeId) => {
  return useQuery("GetCodeLevels", () => getCodeLevels(businessTypeId), {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export default useGetCodeLevels;
